import { LocationDescriptor } from 'history';
import { forwardRef } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { useApplicationContext } from '../../hooks/Context';

const createPath = (urlBasePath: string, path: string): string => {
  if (path.startsWith('/')) {
    path = path.slice(1);
  }
  return `${urlBasePath}${path}`;
};

// ListItemButton から使用するため forwardRef でラップする
export const AppLink = forwardRef<
  HTMLAnchorElement,
  React.PropsWithChildren<Omit<LinkProps, 'to'> & { to: LocationDescriptor }>
>(({ children, ...props }, ref) => {
  // / or /sf/
  const { urlBasePath } = useApplicationContext();
  const { to } = props;
  // toが示す遷移先に固定のプレフィクスを付与する
  let prefixedTo: LocationDescriptor;

  if (typeof to === 'string') {
    prefixedTo = createPath(urlBasePath, to);
  } else {
    const pathname =
      to.pathname !== undefined
        ? createPath(urlBasePath, to.pathname)
        : undefined;
    prefixedTo = {
      ...to,
      pathname,
    };
  }
  return (
    <Link {...props} to={prefixedTo} ref={ref}>
      {children}
    </Link>
  );
});
AppLink.displayName = 'AppLink';
